import { Licenses } from "../Data/Licenses.ts";
import { useParams } from "../Providers/ParamsProvider";

const useCheckLicense = () => {
  const { license } = useParams();

  const checkLicense = (allowedLicenses: Licenses[]): boolean => {
    if (!license || license.trim() === "") {
      return false;
    }
    if (license === Licenses.Ferrodo) {
      //wszystkie opcje dla ferrodo
      return true;
    }

    return allowedLicenses.includes(license as Licenses);
  };

  return { checkLicense };
};

export default useCheckLicense;
